export const ROOM_RESOURCE_STATE_CHANGED = "room-resource-state-changed";

export const RoomResourceIds = Object.freeze({
  MICROPHONE: "media.microphone",
  CAMERA: "media.camera",
  SCREEN_SHARE: "media.screenShare"
});

const RESOURCE_LIMIT_KEYS = Object.freeze({
  [RoomResourceIds.MICROPHONE]: "maxMicrophones",
  [RoomResourceIds.CAMERA]: "maxCameras",
  [RoomResourceIds.SCREEN_SHARE]: "maxScreenShares"
});

export function getRoomResource(snapshot, resourceId) {
  return snapshot?.resources?.[resourceId] || null;
}

export function isRoomResourceAvailable(snapshot, resourceId) {
  const resource = getRoomResource(snapshot, resourceId);

  if (!resource || resource.limit === null || resource.limit === undefined) {
    return true;
  }

  if (typeof resource.available === "number") {
    return resource.available > 0;
  }

  if (typeof resource.used === "number" && typeof resource.limit === "number") {
    return resource.used < resource.limit;
  }

  return !resource.exhausted;
}

export function canAcquireRoomResource(dialog, resourceId) {
  if (dialog?.canAcquireRoomResource) {
    return dialog.canAcquireRoomResource(resourceId);
  }

  return isRoomResourceAvailable(dialog?.roomResourceState, resourceId);
}

function normalizeRoomResourceLimit(value) {
  const parsed = typeof value === "string" && value.trim() !== "" ? Number(value) : value;

  if (typeof parsed !== "number" || !Number.isFinite(parsed) || parsed < 0) {
    return null;
  }

  return Math.floor(parsed);
}

export function applyRoomResourceLimits(snapshot, limits) {
  let changed = false;
  const resources = { ...(snapshot?.resources || {}) };

  for (const resourceId of Object.values(RoomResourceIds)) {
    const resource = resources[resourceId];
    const limit = normalizeRoomResourceLimit(limits?.[RESOURCE_LIMIT_KEYS[resourceId]]);

    if (limit === null) {
      continue;
    }

    const used = typeof resource?.used === "number" ? resource.used : 0;

    resources[resourceId] = {
      ...resource,
      limit,
      used,
      available: Math.max(0, limit - used),
      exhausted: used >= limit
    };
    changed = true;
  }

  if (!changed) {
    return snapshot || null;
  }

  return { ...(snapshot || {}), resources };
}
